(() => {
  const runtimeKey = "__logenokCourseResultsRuntime";

  if (window[runtimeKey]) {
    return;
  }

  window[runtimeKey] = true;

  const sectionSelector = "[data-logenok-course-results]";

  function initializeSection(section) {
    if (!section || section.dataset.resultsInitialized === "true") {
      return;
    }

    section.dataset.resultsInitialized = "true";

    const resultItems = Array.from(
      section.querySelectorAll("[data-result-item]")
    );

    const lightbox = section.querySelector("[data-results-lightbox]");
    const lightboxMedia = section.querySelector(
      ".logenok-course-results__lightbox-media"
    );
    const lightboxImage = section.querySelector("[data-lightbox-image]");
    const lightboxCaption = section.querySelector("[data-lightbox-caption]");
    const lightboxCounter = section.querySelector("[data-lightbox-counter]");
    const closeButton = section.querySelector("[data-lightbox-close]");
    const previousButton = section.querySelector("[data-lightbox-previous]");
    const nextButton = section.querySelector("[data-lightbox-next]");
    const backdropButton = section.querySelector("[data-lightbox-backdrop]");

    if (
      resultItems.length === 0 ||
      !lightbox ||
      !lightboxMedia ||
      !lightboxImage ||
      !closeButton
    ) {
      return;
    }

    const abortController = new AbortController();
    const eventOptions = {
      signal: abortController.signal
    };

    section.logenokResultsAbortController = abortController;

    let activeIndex = 0;
    let lastFocusedElement = null;

    function normalizeIndex(index) {
      if (index < 0) {
        return resultItems.length - 1;
      }

      if (index >= resultItems.length) {
        return 0;
      }

      return index;
    }

    function resetLightboxScroll() {
      lightboxMedia.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto"
      });
    }

    function renderResult(index) {
      activeIndex = normalizeIndex(index);

      const activeItem = resultItems[activeIndex];
      const imageUrl = activeItem.dataset.fullImage || "";
      const imageAlt = activeItem.dataset.resultAlt || "";
      const imageCaption = activeItem.dataset.resultCaption || "";

      resetLightboxScroll();

      lightboxImage.src = imageUrl;
      lightboxImage.alt = imageAlt;

      if (lightboxCaption) {
        lightboxCaption.textContent = imageCaption;
      }

      if (lightboxCounter) {
        lightboxCounter.textContent = `${activeIndex + 1} / ${
          resultItems.length
        }`;
      }

      window.requestAnimationFrame(resetLightboxScroll);
    }

    function openLightbox(index, triggerElement) {
      lastFocusedElement = triggerElement || document.activeElement;

      renderResult(index);

      lightbox.hidden = false;
      lightbox.setAttribute("aria-hidden", "false");
      document.body.classList.add("logenok-results-lightbox-open");

      window.requestAnimationFrame(() => {
        resetLightboxScroll();
        closeButton.focus();
      });
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lightbox.setAttribute("aria-hidden", "true");
      document.body.classList.remove("logenok-results-lightbox-open");

      lightboxImage.removeAttribute("src");
      lightboxImage.alt = "";
      resetLightboxScroll();

      if (
        lastFocusedElement &&
        typeof lastFocusedElement.focus === "function"
      ) {
        lastFocusedElement.focus();
      }
    }

    function showPreviousResult() {
      renderResult(activeIndex - 1);
    }

    function showNextResult() {
      renderResult(activeIndex + 1);
    }

    resultItems.forEach((item, index) => {
      item.addEventListener(
        "click",
        () => {
          openLightbox(index, item);
        },
        eventOptions
      );
    });

    lightboxImage.addEventListener(
      "load",
      () => {
        resetLightboxScroll();
      },
      eventOptions
    );

    closeButton.addEventListener("click", closeLightbox, eventOptions);

    if (backdropButton) {
      backdropButton.addEventListener("click", closeLightbox, eventOptions);
    }

    if (previousButton) {
      previousButton.addEventListener(
        "click",
        showPreviousResult,
        eventOptions
      );
    }

    if (nextButton) {
      nextButton.addEventListener("click", showNextResult, eventOptions);
    }

    document.addEventListener(
      "keydown",
      (event) => {
        if (lightbox.hidden) {
          return;
        }

        if (event.key === "Escape") {
          event.preventDefault();
          closeLightbox();
          return;
        }

        if (event.key === "ArrowLeft") {
          event.preventDefault();
          showPreviousResult();
          return;
        }

        if (event.key === "ArrowRight") {
          event.preventDefault();
          showNextResult();
        }
      },
      eventOptions
    );
  }

  function initializeAllSections(scope = document) {
    if (scope.matches && scope.matches(sectionSelector)) {
      initializeSection(scope);
    }

    scope.querySelectorAll(sectionSelector).forEach((section) => {
      initializeSection(section);
    });
  }

  function destroySection(scope) {
    const section =
      scope.matches && scope.matches(sectionSelector)
        ? scope
        : scope.querySelector(sectionSelector);

    if (!section) {
      return;
    }

    if (section.logenokResultsAbortController) {
      section.logenokResultsAbortController.abort();
    }

    document.body.classList.remove("logenok-results-lightbox-open");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializeAllSections();
    });
  } else {
    initializeAllSections();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeAllSections(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    destroySection(event.target);
  });
})();